import { ajax } from '@setel/webcommon/exposes/ajax';
import { environments } from 'environments/environment';
import { IUserTierProgress } from 'shared/interfaces/membership.interface';

const BASE_URL = `${environments.apiOpsBaseUrl}/api/membership`;

export const getUserTierProgress = (userId: string) =>
  ajax.get<IUserTierProgress>(`${BASE_URL}/admin/user/${userId}/tier/progress`);
